import { UserType } from "../../types/User.ts";

export const EMPTY_USER_PROFILE: UserType = {
  _id: "",
  username: "",
  description: "",
};
